import React from "react";

const GlassesSpinner = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <svg
        className="animate-pulse w-24 h-24 text-zinc-700"
        viewBox="0 0 64 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="4" />
        <circle cx="48" cy="16" r="12" stroke="currentColor" strokeWidth="4" />
        <line
          x1="28"
          y1="16"
          x2="36"
          y2="16"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
      <p className="mt-4 text-zinc-600 font-medium">Loading history...</p>
    </div>
  );
};

export default GlassesSpinner;
